import PageContainer from '../layout/PageContainer'
import DataTable from '../dataTable/DataTable'
import StoreKeyProvider from '../../providers/StoreKeyProvider'
import WithFilters from '../../hocs/WithFilters'
import { Card, CardContent, Button, CardHeader } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { useDispatch } from 'react-redux'
import { openPopup } from '../../../store/popupsSlice'
import DataInputs from '../dataTable/DataInputs'
import PropTypes from 'prop-types'

const PatientNotes = ({ patientId }) => {
  const dispatch = useDispatch()

  return (
    <>
      <PageContainer>
        <StoreKeyProvider storeKey="PatientNotesKey">
          <WithFilters
            config={{
              page: 1,
              paginate: 10,
              orderType: 'desc',
              order: 'created_at',
              inputs: {
                name: {
                  value: '',
                  relation: 'LIKE',
                },
                user_name: {
                  value: '',
                  relation: 'LIKE',
                },
                min_created_at: {
                  value: null,
                  relation: 'MIN',
                },
                max_created_at: {
                  value: null,
                  relation: 'MAX',
                },
              },
            }}
            endpoint={`/patients/${patientId}/notes/filter`}
          >
            <Card elevation={2} square>
              <CardHeader
                title="Lista notatek"
                action={
                  <Button
                    startIcon={<AddIcon />}
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      dispatch(
                        openPopup({
                          component: 'PatientNoteFactory',
                          title: 'Dodaj notatkę',
                          level: 1,
                          maxWidth: 'xl',
                          key: 'patient-note-factory-popup',
                          values: {
                            patient_id: patientId,
                          },
                        })
                      )
                    }
                  >
                    Dodaj
                  </Button>
                }
              ></CardHeader>
              <CardContent>
                <DataInputs
                  inputs={[
                    {
                      id: 'user_name',
                      label: 'Użytkownik',
                      placeholder: '',
                      type: 'text',
                    },
                    {
                      id: 'created_at',
                      label: 'Data wykonania',
                      placeholder: '',
                      type: 'date-between',
                    },
                  ]}
                />
                <DataTable
                  breakpoint={1614}
                  actions="PatientNotesTableActions"
                  rowStyles={{
                    medical_facility_name: {
                      maxWidth: '300px',
                    },
                  }}
                  labels={['Nazwa', 'Użytkownik', 'Data utworzenia']}
                  keys={['name', 'user_name', 'created_at']}
                />
              </CardContent>
            </Card>
          </WithFilters>
        </StoreKeyProvider>
      </PageContainer>
    </>
  )
}

PatientNotes.propTypes = {
  patientId: PropTypes.any,
}

export default PatientNotes
